// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // budgetorUrl: 'http://localhost:4300/auth/login',
  // budgetorUrl: 'http://galisur-app.web.app/auth/login',
  budgetorUrl: 'https://gptechnicbasic.galisur.es/auth/login',

  // apiUrl: 'https://staging.galisur.aratech.org/api/',
  // apiUrl: 'https://dev.galisur.aratech.org/api/',
  // apiUrl: 'http://localhost:3000/api/',
  apiUrl: 'https://gptechnicbasic.galisur.es/api/',
  // apiUrl: '/api/',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
